// extracted by mini-css-extract-plugin
export default {"title":"App_title_UjfR7","nav":"App_nav_wpvVx","navItem":"App_navItem_tXs5Z"};